import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { HiChevronRight } from "react-icons/hi2";
import FlightListIndividualItem from "./FlightListIndividualItem";
import { FaCircleInfo } from 'react-icons/fa6';
import { useEffect, useState } from "react";
import FareOptionsSelectRadio from "./FareOptionsSelectRadio";
import FlightDetailPreviewSheet from "./FlightDetailPreviewSheet";
import FareOptionsSheet from "./search/FareOptionsSheet";
import { checkTransitInfo, holdFlight, holdHoldedFlightItem } from "../actions/flightAction";
import { toast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import Login from "../pages/Login";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { FormControl } from "@/components/ui/form";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { LuChevronDown } from "react-icons/lu";
import { useMediaQuery } from "@/hooks/use-media-query";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"

export default function FlightListItem({
  flight,
  IsHolding
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { searchForm } = useSelector((state) => state.flights);
  const { token } = useAuth();
  const [flightDetailForPreview, setFlightDetailsForPreview] = useState({ ...flight, FareOptions: flight.FareOptions[0] });
  const [selectedFareType, setSelectedFareType] = useState(flightDetailForPreview ? flightDetailForPreview.FareOptions.BookingKey : flight.FareOptions[0].BookingKey);
  const [showPreview, setShowPreview] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [transitInfos, setTransitInfos] = useState([]);
  const [showBookConfirm, setShowBookConfirm] = useState(false);
  const [showFareOptions, setShowFareOptions] = useState(false);

  useEffect(() => {
    setSelectedFareType(flightDetailForPreview.FareOptions.BookingKey);
  }, [flightDetailForPreview])
  const fareTypeChangeEvent = (value) => {
    let currFlight = { ...flight, FareOptions: flight.FareOptions.filter(fo => fo.BookingKey === value)[0] }
    setFlightDetailsForPreview(currFlight);
    setSelectedFareType(value);
  }
  const handleBookFlight = (flight) => {
    dispatch(holdHoldedFlightItem(flight));
    let transitAirports = [];
    let destAirport = "";
    flight.OriginDest.forEach((item) => {
      item.FlightDetails.forEach((flight) => {
        destAirport = item.Destination;
        if (transitAirports.indexOf(ta => ta == flight.ArrivalAirport.Code) <= 0 && flight.ArrivalAirport.Code != destAirport) {
          transitAirports.push(flight.ArrivalAirport.Code)
        }
      })
    });
    console.log("item", transitAirports);
    let payload = {
      nationality: searchForm.nationality,
      transitAirports,
      destAirport,
    };
    dispatch(
      checkTransitInfo(payload, (resp) => {
        if (resp.data && resp.data.length == 0) {
          handleBookNowClick(flight);
        }
        else {
          setShowBookConfirm(true);
          // var dummyTransitInfo = [{
          //   Title: "Transit Title",
          //   Message: "Transit Message"
          // }, {
          //   Title: "Transit Title 2",
          //   Message: "Transit Message 2"
          // }]
          // setTransitInfos(dummyTransitInfo)
          setTransitInfos(resp.data)
        }
      })
    );
  };
  const handleBookNowClick = (flight) => {
    let holdFlightPayload = {
      paxTypes: [],
      departureDate: searchForm.departure,
      returnDate: searchForm.return,
      destination: searchForm.to,
      origin: searchForm.from,
      prevTranID: localStorage.transId ?? '',
      cabinClass: searchForm.cabinClass,
      tripType: flight.Direction === "OneWay" ? 1 : 2,
      supplier: flight.SupplierID,
      nationality: searchForm.nationality,
      inventoryID: flight.InventoryID.toString() ?? "",
      fareBookingKey: flight.FareOptions.BookingKey,
      fareType: searchForm.fareType
    }
    flight.FareOptions.FareBreakDowns.forEach((fbd) => {
      holdFlightPayload.paxTypes.push({
        quantity: fbd.Passenger.QTY,
        code: fbd.Passenger.Code,
        typeName: null,
      });
    });
    funcHoldFlight(holdFlightPayload);
  };
  const funcHoldFlight = (pyld) => {
    IsHolding(true);
    dispatch(
      holdFlight(pyld, (resp) => {
        IsHolding(false);
        if (resp && !resp.IsComplete && resp.Error) {
          toast({
            variant: "error",
            title: resp.Error.ErrorType,
            description: resp.Error.Message,
          });
        }

        if (resp.IsComplete) {
          setShowPreview(false);
          navigate("/review");
        }
      })
    );
  };
  const fareLength = flight.FareOptions && flight.FareOptions.length;
  return (
    <>
      <style>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <AlertDialog open={showBookConfirm} onOpenChange={setShowBookConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Transit Information</AlertDialogTitle>
            <AlertDialogDescription >
              {transitInfos && transitInfos.length > 0 && transitInfos.map((info) => {
                return (
                  <div key={info.Title} class="mt-2">
                    <h2 class="font-bold">
                      {info.Title}:
                    </h2>
                    <p class="mt-2 pb-2 text-lg">
                      {info.Message}
                    </p>

                  </div>
                );
              })}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => {
              handleBookNowClick(flightDetailForPreview);
            }}>Continue</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog >
      <Card className="mb-3">
        <div className="text-sm p-2 md:p-4">
          <div className="col-span-6 grid grid-cols-4 gap-1 md:gap-4">
            {flight.OriginDest.map((od, i, array) => {
              return (
                <FlightListIndividualItem
                  flight={od}
                  array={array}
                  key={i}
                  carrier={flight.ValidatingCarrier}
                  isManual={flight.IsManual}
                />
              );
            })}
          </div>
        </div>
        <div className="flex flex-wrap border-t p-3 items-center gap-4">
          <div className="flex-1 min-w-0">
            {isDesktop ?
              <FareOptionsSelectRadio
                compId={"list"}
                flight={flight}
                value={selectedFareType}
                currentFlightInfo={flightDetailForPreview}
                onValueChange={fareTypeChangeEvent}
                onInfoClick={() => setShowFareOptions(true)}
                from={"list"} />
              :
              fareLength > 1 ?
                <div className="flex flex-col items-end">
                  <div className="flex items-center gap-2" onClick={() => setShowFareOptions(true)}>
                    <div className="text-right">
                      <span className='block text-xs font-bold text-primary underline'>More Fare Options</span>
                      <span className='block text-xs text-muted-foreground'>{flightDetailForPreview.FareOptions.FareType}</span>
                      <span className='text-lg font-semibold leading-6'>
                        <span className='text-sm'>{flightDetailForPreview.FareOptions.Currency} </span>
                        <span>{flightDetailForPreview.FareOptions.GTotalFare}</span>
                      </span>
                    </div>
                  </div>
                </div>
                :
                <div className="inline-flex items-center gap-2 w-full justify-end" onClick={() => setShowFareOptions(true)}>
                  <div className="text-right">
                    <span className='block text-xs text-muted-foreground'>{flightDetailForPreview.FareOptions.FareType}</span>
                    <span className='text-lg font-semibold leading-6 flex items-center gap-1 justify-end'>
                      <span className='text-sm'>{flightDetailForPreview.FareOptions.Currency} </span>
                      <span>{flightDetailForPreview.FareOptions.GTotalFare}</span>
                      <FaCircleInfo
                        className="text-primary hover:text-primary/80 cursor-pointer text-base ml-1.5"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setShowFareOptions(true);
                        }}
                      />
                    </span>
                  </div>
                </div>
            }
          </div>

          <div className="flex-none ml-auto ps-4 lg:border-s border-dotted">
            <Button
              onClick={() => {
                if (!token) {
                  setShowLoginForm(true);
                } else handleBookFlight(flightDetailForPreview);
              }}
            >
              Book Now
            </Button>
          </div>
        </div>

        <div className="flex items-center justify-between dark:bg-gray-700 bg-gray-200/50 px-3">
          {/* <span className="text-muted-foreground text-sm">{flight.FareOptions[0].NonRefundable && "Non-Refundable"}</span> */}

          {flightDetailForPreview.FareOptions.NonRefundable ? (
            <span className="text-muted-foreground text-sm">Non-Refundable</span>
          ) : (
            <span className="text-primary text-sm">Refundable</span>
          )}
          <Button
            onClick={() => {
              setShowPreview(true);
            }}
            variant="link"
            className="px-0"
          >
            Flight Details
            <HiChevronRight className="ml-2" />
          </Button>
        </div>
      </Card>
      {
        flightDetailForPreview && (
          <FlightDetailPreviewSheet
            key={"FlightDetailPreview"}
            open={showPreview}
            openchange={setShowPreview}
            flightInfo={flight}
            handleBookItemCallback={() => {
              if (!token) {
                setShowLoginForm(true);
              } else {
                handleBookFlight(flightDetailForPreview);
              }
            }}
            fareTypeChangeEvent={fareTypeChangeEvent}
            selectedFareTypeFlight={flightDetailForPreview}
          ></FlightDetailPreviewSheet >
        )
      }
      {
        flight && (
          <FareOptionsSheet
            open={showFareOptions}
            onOpenChange={setShowFareOptions}
            flight={flight}
            selectedFareKey={selectedFareType}
            onSelectFare={fareTypeChangeEvent}
          />
        )
      }
      <Dialog
        open={showLoginForm}
        onOpenChange={setShowLoginForm}
      >
        <DialogContent>
          <Login
            fromLogin
            handleClose={(token) => {
              setShowLoginForm(false)
              if (token) {
                handleBookFlight(flightDetailForPreview);
              }
            }}
          />

          {/* <DialogFooter>
          <Button type="submit">Save changes</Button>
        </DialogFooter> */}
        </DialogContent>
      </Dialog>
    </>

  );
}
